import { useRecoilValue } from 'recoil';
import AiAgentConversation from '../aiAgent/store/AiAgentConversation';
import { useAskSimulationAgent } from '../warehouse/hooks/useAskSimulationAgent';
import { useLoadSimulationAiQueries } from '../warehouse/hooks/useLoadSimulationAiQueries';
import { simulationCurrentId } from './store/simulation.state';

const SimulationAiAgentConversation: React.FC = () => {
  const simulationId = useRecoilValue(simulationCurrentId);
  const [ask] = useAskSimulationAgent();
  const [loadAiQueries] = useLoadSimulationAiQueries();

  function onMessageAdded(message: string) {
    ask({ question: message });
  }

  return (
    <AiAgentConversation
      loadAiQueries={params => loadAiQueries({ ...params, simulationId })}
      onMessageAdded={onMessageAdded}
    />
  );
};

export default SimulationAiAgentConversation;
